"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FerpaService = void 0;
var axios_1 = __importDefault(require("axios"));
var FerpaService = (function () {
    function FerpaService(token, profileId) {
        this.baseUrl = process.env.EDULAR_CORE_API_BASE_URL;
        this.token = token;
        this.profileId = profileId;
    }
    FerpaService.prototype.getAllFerpaAcademicFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, params, res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/ferpa-academic-fields/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        params = {
                            filter: { isActive: true },
                            sort: { orderBy: "name", orderDir: "asc" }
                        };
                        return [4, axios_1.default.post(url, params, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.listStudentRelationshipAddress = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/student-relationship-addresses/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, params, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.createStudentRelationshipAddress = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/student-relationship-addresses/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_3 = _a.sent();
                        console.log(error_3);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.updateStudentRelationshipAddress = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/student-relationship-addresses/edit");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_4 = _a.sent();
                        console.log(error_4);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.listFerpaSetudents = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/ferpa-students/list");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_5 = _a.sent();
                        console.log(error_5);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.createFerpaStudents = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/ferpa-students/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_6 = _a.sent();
                        console.log(error_6);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.updateFerpaStudents = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/ferpa-students/edit");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_7 = _a.sent();
                        console.log(error_7);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.updateAcademicFields = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/ferpa-students/update-academic-fields");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_8 = _a.sent();
                        console.log(error_8);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    FerpaService.prototype.createFerpaStudentsAcademicFields = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v1/ferpa-students-academic-fields/create");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "X-Profile-Id": this.profileId
                            }
                        };
                        return [4, axios_1.default.post(url, data, configuration)];
                    case 2:
                        res = _a.sent();
                        return [2, res.data.data];
                    case 3:
                        error_9 = _a.sent();
                        console.log(error_9);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    };
    return FerpaService;
}());
exports.FerpaService = FerpaService;
//# sourceMappingURL=data:application/json;base64,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